import { render } from "./BienvenueView.vue?vue&type=template&id=6c62facd&scoped=true"
import script from "./BienvenueView.vue?vue&type=script&lang=js"
export * from "./BienvenueView.vue?vue&type=script&lang=js"

import "./BienvenueView.vue?vue&type=style&index=0&id=6c62facd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c62facd"]])

export default __exports__